/**
 * Travel Google Maps runtime contract (MAP-GOOGLE-RENDERER-C3).
 *
 * Planning / Publication / Explore-Social use Google Maps JS when browser credentials are present.
 * Browser key reuses REACT_APP_GOOGLE_PLACES_BROWSER_* with optional neutral alias.
 */

function readEnv(env, key) {
  const value = env?.[key];
  return typeof value === 'string' ? value.trim() : '';
}

/**
 * Browser key; backward compatible with legacy Places env names.
 */
export function readGoogleMapsBrowserKey(env = process.env) {
  return readEnv(env, 'REACT_APP_GOOGLE_MAPS_BROWSER_KEY')
    || readEnv(env, 'REACT_APP_GOOGLE_PLACES_BROWSER_KEY');
}

/**
 * Browser enable flag; backward compatible with legacy Places env names.
 */
export function isGoogleMapsBrowserEnabled(env = process.env) {
  const neutral = readEnv(env, 'REACT_APP_GOOGLE_MAPS_BROWSER_ENABLED');
  const legacy = readEnv(env, 'REACT_APP_GOOGLE_PLACES_BROWSER_ENABLED');
  const raw = neutral || legacy;
  return String(raw).toLowerCase() === 'true';
}

/** True when Google Maps JS can load (enabled flag + browser key). */
export function isGoogleMapsRuntimeAvailable(env = process.env) {
  return isGoogleMapsBrowserEnabled(env) && Boolean(readGoogleMapsBrowserKey(env));
}
